import { compose, branch, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { isLoading } from 'e-submission/apps/selectors'
import { get } from 'lodash/fp'

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1060;
`
export const Loading = ({ className }) => {
  return (
    <Wrapper id="main-wrapper" className={className}>
      <div id="loader">
        <h6 className="status"></h6>
        <div id="spinner" />
      </div>
    </Wrapper>
  )
}

export default compose(
  connect(
    (state) => {
      return { showLoading: isLoading(state), message: get('ui.loadingMessage', state) }
    },
    (dispatch) => ({})
  ),
  branch(({ showLoading }) => !showLoading, renderNothing)
)(Loading)
